import { loadScript } from './load'

const LEADINFO_SITE_ID = 'LI-6811EDE92B91A'

type LeadinfoStub = ((...args: unknown[]) => void) & { q?: unknown[]; t?: string }

declare global {
  interface Window {
    leadinfo?: LeadinfoStub
    GlobalLeadinfoNamespace?: string[]
  }
}

export async function loadLeadinfo(): Promise<void> {
  if (!import.meta.env.PROD) return

  const w = window
  const i = 'leadinfo'
  const n = LEADINFO_SITE_ID

  if (w.leadinfo) return

  w.GlobalLeadinfoNamespace = w.GlobalLeadinfoNamespace || []
  w.GlobalLeadinfoNamespace.push(i)

  const stub: LeadinfoStub = function (...args: unknown[]) {
    const q = (stub.q = stub.q || [])
    q.push(args)
  }
  stub.t = n
  stub.q = []
  w.leadinfo = stub

  await loadScript('https://cdn.leadinfo.net/ping.js', { id: 'leadinfo-script' })
}
